import { FieldBase, IFieldOptions } from './field-base.interface'

export class SelectField extends FieldBase<any> {
  controlType = 'select'
  options: string[] | number[]
  compareWith: (o1: string | number, o2: string | number) => boolean = (o1: string|number, o2: string|number) => o1 === o2

  constructor(options: IFieldOptions<any> = {}) {
    super(options)
    this.options = options['options'] || []
  }
}
